import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import { createI18n } from "vue-i18n";
import ar from "./locales/ar.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import th from "./locales/th.json";
import zh from "./locales/zh.json";
import rocket8 from "./locales/theme/rocket8.json";
import beemove from "./locales/theme/beemove.json";

// function loadLocaleMessages () {
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
//   const messages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
//   return messages
// }

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_PROVIDER || "rocket8",
  fallbackLocale: process.env.VUE_APP_PROVIDER || "rocket8",
  messages: {
    ar,
    en,
    es,
    fr,
    th,
    zh,
    rocket8,
    beemove
  }
  // loadLocaleMessages()
});
